/* eslint-disable sort-keys */
import { useEffect, useState, useRef } from 'react'

import { Form, Button, Row } from 'components'
import { useAuth, useLoading, useModal, useToggle } from 'hooks'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import {
  AddAnalyzeCREServices,
  RequestCreateItemAnalise,
  ResponseAnaliseCREInicial,
  ResponseMovimentacao,
  RequestUpdateCreAnalise,
  RequestSetDisponibilidade,
  RequestCreateCodigoCRE,
  ResponseCreateCodigoCRE,
  RequestDeleteCodigoCRE,
  ResponseEfetivoMovimentacao,
  AnalyzeCREServices
} from 'services/NGT/AnalyzeCRE'
import { COLORS, FORMAT, SPACING } from 'utils'
import { generateAleatoryID } from 'utils/functions'
import { boolean } from 'yup'

import {
  ContratoPrincipalCollapse,
  AnaliseCollapse,
  EncargosCollapse,
  PagamentoCollpase,
  TipoEfetivoCollapse,
  DadosEfetivoCollapse,
  HeaderNovoCRE,
  DemaisInformacoesCollapse,
  EfetivosCadastradosCollapse,
  DenunciaAlertaCollapse
} from './components'
import { ITableEfetivos } from './components/EfetivosCadastradosCollapse'
import { ContractServices } from 'services/NGT/Contract'
import {
  connectionLostError,
  hasConnectionLostError
} from 'services/Instances/utils'

export interface IAddAnalysisCreForm {
  cdContrato: string
  nmFornecedor: string
  NuAnoMesCompetencia: string
  flStatusMoblizacao: string
  txObjetoContrato: string
  dtEntradaCRE: Date | string
  dtRetornoCRE: Date | string
  dtLiberacaoCRE: Date | string
  flBloqueado: boolean
  numAnalise: number
  qtAtivo: string
  qtDemitido: string
  qtAcesso: string
  notificacao: string
  qtTransferido: string
  qtAfastado: string
  qtCompartilhado: string
  qtTotalEfetivo: string
  qtClt: string
  qtPendencias: number
  qtSocio: string
  qtCooperado: string
  qtEstrangeiro: string
  qtMei: string
  qtAutonomo: string
  qtHeNormal: string
  qtHeQtd: string
  vlHoraExtras: string
  vlSalBase: string
  flLiberado: boolean
  vlFolhaPagto: string
  vlrGPS: string
  vlrGFIP: string
  vlrDAS: string
  txCNO: string
  cdContratoPrincipal: string
  nmFornecedorPrincipal: string
  txObjetoContratoPrincipal: string
  tipoDocumento: string
  nmAnalista: string
  txObservacao: string
  cdMatricula: string
  valorRisco: string
  observacao: string
  flMobilizacao: boolean
  flSemMob: boolean
  flCompartilhado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  idCre?: number
  cdDocto: string
  txDenuncia: string
  txAlerta: string
}

const optsCategoria = {
  A: 'Administrativo',
  O: 'Operacional'
}

const optsNacionalidade = {
  B: 'Brasileiro',
  E: 'Estrangeiro'
}

const optsGenero = {
  F: 'Feminino',
  M: 'Masculino',
  O: 'Prefiro não informar'
}

const DEFAULT_FORM: IAddAnalysisCreForm = {
  NuAnoMesCompetencia: moment().toISOString(),
  cdContrato: '',
  cdContratoPrincipal: '',
  cdMatricula: '',
  dtEntradaCRE: undefined,
  dtLiberacaoCRE: undefined,
  dtRetornoCRE: undefined,
  flBloqueado: false,
  flCompartilhado: false,
  flDenuncia: false,
  flAlerta: false,
  flLiberado: false,
  flMobilizacao: false,
  flSemMob: false,
  flStatusMoblizacao: '',
  nmAnalista: '',
  nmFornecedor: '',
  nmFornecedorPrincipal: '',
  notificacao: '',
  numAnalise: 0,
  observacao: '',
  qtAcesso: '',
  qtAfastado: '',
  qtAtivo: '',
  qtAutonomo: '',
  qtClt: '',
  qtCompartilhado: '',
  qtCooperado: '',
  qtDemitido: '',
  qtEstrangeiro: '',
  qtHeNormal: '',
  qtHeQtd: '',
  qtMei: '',
  qtPendencias: 0,
  qtSocio: '',
  qtTotalEfetivo: '',
  qtTransferido: '',
  tipoDocumento: '',
  txCNO: '',
  txObjetoContrato: '',
  txObjetoContratoPrincipal: '',
  txObservacao: '',
  valorRisco: '',
  vlFolhaPagto: '',
  vlHoraExtras: '',
  vlSalBase: '',
  vlrDAS: '',
  vlrGFIP: '',
  vlrGPS: '',
  cdDocto: '',
  txDenuncia: '',
  txAlerta: ''
}
interface IAddAnalysisCre {
  cdContratoCre: number | string | null | undefined
  NuAnoMesCompetenciaCre: Date | undefined | null
  nmFornecedor: string | null | undefined
  handleChangeName: (_newName: string) => void
  pathBack?: string
  tabBack?: number
  idCreExist: number
  isConsult?: boolean
}

export const AddAnalysisCre: React.FC<IAddAnalysisCre> = ({
  tabBack,
  pathBack,
  handleChangeName,
  idCreExist,
  NuAnoMesCompetenciaCre,
  cdContratoCre,
  nmFornecedor
}) => {
  const { user, usuarioCsn } = useAuth()
  const history = useHistory()
  const idCre = useRef<number>(0)
  const [hasQuestion, setHasQuestion] = useToggle(false)
  const [creOcupado, setCreOcupado] = useState<boolean>(null)
  const [haveMobilizacao, setHaveMobilizacao] = useState<boolean>(false)
  const [hasContratoPrincipal, setHasContratoPrincipal] = useState(false)
  const [cre, setCre] = useState<ResponseAnaliseCREInicial | undefined>()
  const [buscouCre, setBuscouCre] = useState<boolean>(false)
  const saveCre = useRef<boolean>(false)
  const [primeiroAcesso, setPrimeiroAcesso] = useState<boolean>(true)
  const [iniciarPing, setIniciarPing] = useState<boolean>(false)
  const [novaAnalise, setNovaAnalise] = useState<boolean>(false)
  const [fornecedorBloqueado, setFornecedorBloqueado] = useState<boolean>(false)
  const [pesquisaComSucesso, setPesquisaComSucesso] = useState<boolean>(true)
  const [isConsult, setIsConsult] = useState<boolean>(false)
  const [listAnalises, setListAnalises] = useState<
    RequestCreateItemAnalise[] | []
  >([])
  const [listNewItensAnalise, setListNewItensAnalise] = useState<
    RequestCreateItemAnalise[]
  >([])
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()

  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [totalItems, setTotalItems] = useState<number>(0)

  const [efetivoTableData, setEfetivoTableData] = useState<
    ResponseEfetivoMovimentacao[]
  >([])

  const [listPendenciaOnDelete, setListPendenciaOnDelete] = useState<
    RequestDeleteCodigoCRE[]
  >([] as RequestDeleteCodigoCRE[])

  const [ContratoNmCentro, setContratoNmCentro] = useState<string>()
  const [isChecklist, setIsChecklist] = useState<boolean>()

  //Faz a remoção do item dos Dados quando a aba do navegador é fechada
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      localStorage.removeItem('dados')
      exitComponent()
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm<IAddAnalysisCreForm>({
    defaultValues: {
      ...DEFAULT_FORM,
      NuAnoMesCompetencia: NuAnoMesCompetenciaCre
        ? NuAnoMesCompetenciaCre.toString()
        : DEFAULT_FORM.NuAnoMesCompetencia,
      cdContrato: cdContratoCre
        ? cdContratoCre.toString()
        : DEFAULT_FORM.cdContrato,
      nmFornecedor: nmFornecedor
        ? nmFornecedor.toString()
        : DEFAULT_FORM.nmFornecedor,
      idCre: idCreExist ? idCreExist : DEFAULT_FORM.idCre
    }
  })

  // Watch Valores de Movimentação e demais campos
  const codigoContrato = watch('cdContrato')
  const nomeFornecedor = watch('nmFornecedor')
  const creObservacoes = watch('txObservacao')
  const statusMobilizacao = watch('flStatusMoblizacao')
  const flLiberado = watch('flLiberado')
  const flBloqueado = watch('flBloqueado')
  const qtTotalEfetivo = watch('qtTotalEfetivo')
  const idCreAnalise = watch('idCre')
  let numeroAnalises = watch('numAnalise')
  let competencia = watch('NuAnoMesCompetencia')

  const tableData: ITableEfetivos = {
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    totalItems: totalItems
  }

  const handleSetNmFornecedor = (nmFornecedor: string) => {
    if (nmFornecedor !== nomeFornecedor) setValue('nmFornecedor', nmFornecedor)
  }

  const exitComponent = async () => {
    // Caso análise, ao sair da página cre fica desocupado
    if (novaAnalise)
      SetDisponibilityCRE({
        creId: idCre.current,
        ocuparCre: false
      })

    await CreateCodeCRE({
      creId: idCre.current,
      create: false,
      idUsuario: user.IdUsuario
    })
  }

  const handleSetDisponibilidadeNovaPesquisa = (_idCre?: number) => {
    SetDisponibilityCRE({
      creId: _idCre || idCre.current,
      ocuparCre: false
    })
  }

  const handleGetCreInicialConsulting = async (consulta: boolean) => {
    setLoading('loading')
    setPrimeiroAcesso(false)

    if (idCre.current !== 0) {
      setIniciarPing(false)

      const disponibilidade = await VerificarDisponibilidadeCRE()

      if (disponibilidade.data.entity[0].creOcupado) {
        setLoading('idle')

        showModal({
          hideButtonCancel: true,
          message: 'O CRE já está sendo analisado.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
        return
      }

      handleGetCreInicial(false)
    }
  }

  const handleGetCreInicial = async (
    consulta: boolean,
    mostrarModal = true,
    salvar = false
  ) => {
    setLoading('loading')
    setPrimeiroAcesso(false)

    if (idCre.current !== 0) {
      setIniciarPing(false)
      //handleSetDisponibilidadeNovaPesquisa(idCre.current)
    }

    const competenciaElement = document.getElementById(
      'DatePickerId'
    ) as HTMLInputElement

    const competenciaValue = FORMAT.formatYYYYMM(
      competenciaElement.value.split('/').reverse().toString().replace(',', '')
    )

    if (!competenciaValue) {
      setError('NuAnoMesCompetencia', {
        message: 'Campo Obrigatório'
      })
      setLoading('idle')
      return
    } else if (competenciaValue !== 'Data inválida') {
      clearErrors('NuAnoMesCompetencia')
      competencia = competenciaValue
    } else {
      setError('NuAnoMesCompetencia', {
        message: 'Data inválida'
      })
      setLoading('idle')
      return
    }

    try {
      // BUSCA CRE
      if (!codigoContrato) {
        setError('cdContrato', {
          message: 'Campo Obrigatório'
        })
        setLoading('idle')
        return
      }

      if (!competencia) {
        setError('NuAnoMesCompetencia', {
          message: 'Campo Obrigatório'
        })
        setLoading('idle')
        return
      } else {
        clearErrors('NuAnoMesCompetencia')
      }

      const response = await AddAnalyzeCREServices().getAnaliseCREInicial({
        CdContrato: codigoContrato,
        NuAnoMesCompetencia: competencia
      })

      await ContractServices()
        .getNmCentroByCodigoContrato(response.data.cdContrato)
        .then((data) => setContratoNmCentro(data.data.nmCentro))

      if (response.status !== 200) {
        showModal({
          hideButtonCancel: true,
          message:
            'Não foi encontrado CRE para a competência selecionada, tente novamente.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
        return
      }

      idCre.current = response.data.idCre
      const teste = []
      teste.push(idCre.current)
      const t = await AddAnalyzeCREServices().verificarDisponibilidadeCre(teste)
      if (t.data.entity[0].creOcupado && !salvar) {
        showModal({
          hideButtonCancel: true,
          message:
            'O CRE já está sendo analisado. Será exibido apenas como consulta.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        consulta = true
      }
      setCre(response.data)
      setHaveMobilizacao(response.data.flMobilizacao)
      setValue('vlrDAS', response.data.vlDas.toString())
      setValue('vlrGPS', response.data.vlGps.toString())
      setValue('vlrGFIP', response.data.vlGfip.toString())

      if (response.data.flFornecedorBloqueadoPagamento) {
        setFornecedorBloqueado(true)
      }

      if (response.data.flChecklist) {
        setIsChecklist(true)
      }

      if (response.data.flMobilizacao) {
        setValue('flMobilizacao', true)
        setValue('flSemMob', false)
        // ! GET DATA MOVIMENTACAO
        const responseMovi = await AddAnalyzeCREServices().getMovimentacao(
          response.data.idMovimentacao
        )

        if (responseMovi.status !== 200)
          throw new Error('Não foi possivel obter Movimentacao')

        // ! Get DATA EFETIVOS CADASTRADOS NA MOVIMENTACAO

        await getTableDataEffective(response.data.idMovimentacao)

        handleValuesMov(responseMovi.data)
      } else {
        setValue('flMobilizacao', false)
        setValue('flSemMob', true)
      }

      // ! CREATE CD CRE
      if (!response.data.cdCre && !isConsult) {
        if (!consulta) {
          await CreateCodeCRE({
            creId: response.data.idCre,
            create: true,
            idUsuario: user.IdUsuario
          }).then((resp) => {
            if (!isConsult) {
              handleQuantidadeAnalises(true, response.data.idCre)
              handleChangeName(
                response?.data?.cdCre ? response?.data?.cdCre : resp?.valor
              )
            }
          })
        } else {
          handleChangeName(
            response?.data?.cdCre ? response?.data?.cdCre : 'SEM CÓDIGO CRE'
          )
        }
      } else {
        if (!consulta) {
          handleQuantidadeAnalises(true, response.data.idCre)
        }
        handleChangeName(
          response?.data?.cdCre ? response?.data?.cdCre : 'SEM CÓDIGO CRE'
        )
        saveCre.current = true
      }
      setLoading('loading')
      const responseMovi = await AddAnalyzeCREServices().getDocMov(
        response.data.idMovimentacao
      )
      if (responseMovi.status !== 200)
        throw new Error('Erro pegar dados analise')

      const itemsParaAnalisar = responseMovi.data.map((mov) => ({
        ...mov,
        id: generateAleatoryID(10)
      }))

      setListAnalises(itemsParaAnalisar)
      handleValuesGetInicial(response?.data)
      if (!consulta && mostrarModal) {
        showModal({
          hideButtonCancel: true,
          message: 'Analise Iniciada com Sucesso!',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      }
      setBuscouCre(true)
      clearErrors()
      setLoading('idle')
    } catch (error: any) {
      console.error('handleGetCreInicial error => ', error)
      setLoading('idle')
      handleChangeName('Adicionar Novo')
      setNovaAnalise(false)
      setIniciarPing(false)
      setListAnalises([])
      setCre(undefined)
      setPesquisaComSucesso(false)
      handleReset()
      reset()

      showModal({
        hideButtonCancel: true,
        message:
          'Não foi encontrado CRE para a competência selecionada, tente novamente.',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const SetDisponibilityCRE = async (request: RequestSetDisponibilidade) => {
    try {
      const resp = await AddAnalyzeCREServices().setDisponibilidade(request)

      if (!resp.data.sucesso) {
        throw new Error(
          `${resp?.data?.mensagem || 'Erro ao setar disponiblidade do CRE'}`
        )
      } else if (resp.data.sucesso) {
        return resp
      } else {
        throw resp
      }
    } catch (error: any) {
      throw showModal({
        hideButtonCancel: true,
        message: `${error?.title ||
          error?.message ||
          error?.mensagem ||
          'Erro ao setar disponiblidade do CRE'
          }`,
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const CreateCodeCRE = async (
    request: RequestCreateCodigoCRE
  ): Promise<ResponseCreateCodigoCRE> => {
    if (request.creId === 0) {
      throw console.log('')
    }

    try {
      const resp = await AddAnalyzeCREServices()
        .createCodigoCRE(request)
        .then((resp) => {
          if (!resp.data.sucesso) {
            throw new Error(
              `${resp.data.mensagem || 'Erro ao criar/suspender código CRE'}`
            )
          } else if (resp.data.sucesso) {
            return resp.data
          } else {
            throw resp.data
          }
        })
        .catch((error) => {
          throw error?.title
        })
      return resp
    } catch (error: any) {
      throw showModal({
        hideButtonCancel: true,
        message: `${error?.title ||
          error?.message ||
          error?.mensagem ||
          'Erro ao criar/suspender código CRE'
          }`,
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const handleValuesMov = (movData: ResponseMovimentacao) => {
    // DADOS DO EFETIVO
    setValue('qtAtivo', movData?.qtAtivo.toString())
    setValue('qtDemitido', movData?.qtDemitido.toString())
    setValue('qtAcesso', movData?.qtAcesso.toString())
    setValue('qtTransferido', movData?.qtTransferido.toString())
    setValue('qtAfastado', movData?.qtAfastado.toString())
    setValue('qtCompartilhado', movData?.qtCompartilhado.toString())
    setValue('qtTotalEfetivo', movData?.qtTotalEfetivo.toString())
    setValue('flStatusMoblizacao', movData?.flStatusMoblizacao)

    // TIPO DO EFETIVO
    setValue('qtClt', movData?.qtClt.toString())
    setValue('qtSocio', movData?.qtSocio.toString())
    setValue('qtCooperado', movData?.qtCooperado.toString())
    setValue('qtEstrangeiro', movData?.qtEstrangeiro.toString())
    setValue('qtMei', movData?.qtMei.toString())
    setValue('qtAutonomo', movData?.qtAutonomo.toString())
    //DADOS DA FOLHA DE PAGAMENTO
    setValue('qtHeNormal', String(movData?.qtHeNormal) || '')
    setValue('qtHeQtd', movData?.qtHeQtd.toString())
    setValue('vlHoraExtras', FORMAT.currency(movData?.vlHoraExtras))
    setValue('vlSalBase', FORMAT.currency(movData?.vlSalBase))
    setValue('vlFolhaPagto', FORMAT.currency(movData?.vlFolhaPagto))
  }
  const handleValuesGetInicial = (creInicial: ResponseAnaliseCREInicial) => {
    setHasContratoPrincipal(creInicial?.flContratoPrincipalExistente)
    setValue('txCNO', creInicial?.txCNO)
    setValue('flDenuncia', creInicial?.flDenuncia)
    setValue('flAlerta', creInicial?.flAlerta)
    setValue('txDenuncia', creInicial?.txDenuncia)
    setValue('txAlerta', creInicial?.txAlerta)
    setValue('txObjetoContrato', creInicial?.txObjetoContrato)
    setValue('nmFornecedor', creInicial?.nmFornecedor)
    setValue('numAnalise', creInicial?.qtAnalises)
    setValue('txObservacao', creInicial?.txObservacao)
    setValue('flBloqueado', creInicial?.flBloqueado)
    setValue('flLiberado', creInicial?.flLiberado)
    setValue('nmAnalista', creInicial?.nmAnalista)
    setValue('cdMatricula', creInicial?.cdMatricula)
    setValue('cdDocto', creInicial?.cdDocto)

    if (moment(creInicial?.dtEntradaCRE).year() === 1) {
      setValue('dtEntradaCRE', null)
    } else {
      setValue('dtEntradaCRE', creInicial?.dtEntradaCRE)
    }

    if (moment(creInicial?.dtRetornoCRE).year() === 1) {
      setValue('dtRetornoCRE', null)
    } else {
      setValue('dtRetornoCRE', creInicial?.dtRetornoCRE)
    }

    if (moment(creInicial?.dtLiberacaoCRE).year() === 1) {
      setValue('dtLiberacaoCRE', null)
    } else {
      setValue('dtLiberacaoCRE', creInicial?.dtLiberacaoCRE)
    }

    if (creInicial.flContratoPrincipalExistente) {
      setValue(
        'cdContratoPrincipal',
        creInicial?.cdContratoPrincipal.toString()
      )
      setValue(
        'txObjetoContratoPrincipal',
        creInicial?.txObjetoContratoPrincipal
      )
      setValue('nmFornecedorPrincipal', creInicial?.nmFornecedorPrincipal)
    } else {
      setValue('cdContratoPrincipal', creInicial?.cdContrato.toString())
      setValue('txObjetoContratoPrincipal', creInicial?.txObjetoContrato)
      setValue('nmFornecedorPrincipal', creInicial?.nmFornecedor)
    }
  }

  // const handle

  const handleAddAnalise = (requestData: RequestCreateItemAnalise) => {
    setListNewItensAnalise((old) => [...old, requestData])
    setListAnalises((old) => [...old, requestData])
  }

  const handleQuantidadeAnalises = async (
    novaAnalise: boolean,
    idCre: number
  ) => {
    if (novaAnalise) {
      setNovaAnalise(true)
      setIniciarPing(true)
      await SetDisponibilityCRE({
        creId: idCre || cre?.idCre,
        ocuparCre: true
      })
    } else {
      await SetDisponibilityCRE({
        creId: idCre || cre?.idCre,
        ocuparCre: false
      })
    }
  }

  const getNewAnalises = (): RequestUpdateCreAnalise => {
    const das = parseFloat(watch('vlrDAS')) || 0
    const gfip = parseFloat(watch('vlrGFIP')) || 0
    const gps = parseFloat(watch('vlrGPS')) || 0
    const checklist = cre?.flChecklist

    if (novaAnalise) setValue('numAnalise', (numeroAnalises += 1))

    let creAnaliseItens: any[] = listAnalises
      ?.filter(
        (el: RequestCreateItemAnalise) =>
          (![null, 'Pendente'].includes(el.cdStatus)) &&
          ((![null, undefined].includes(el.liberado)) || ![null, undefined].includes(el.cdStatus)) ||
          el?.flDescChange === true ||
          el?.flQtdPendChange === true
      )
      ?.map((creItem) => ({
        ObservacaoMovDocItem: creItem.txDescricaoAnexo,
        dtLibRecMovDocItem: creItem.dtLiberacao,
        flLiberacao: creItem.liberado ?? (
          checklist === false
            ? (
              creItem.cdStatus === 'Aprovado'
                ? 'item-aprovado-salvo'
                : creItem.cdStatus === 'Recusado'
                  ? 'item-recusado-salvo'
                  : creItem.cdStatus === 'Pendente'
                    ? 'item-pendente-salvo'
                    : null
            )
            : null
        ),
        idCreItem: creItem.idCreItem,
        idMovDocumentoItem: creItem.movDocumentoItemId,
        observacaoCreItem: creItem.txDescricaoAnexo,
        quantidadePendencias: creItem.qtPendencias || 0,
        tipoDocumentoId: creItem.tipoPendenciaId,
        VlRisco: creItem.vlCalcRisco
      }))

    const newCreItensList = listNewItensAnalise?.map((creItem) => ({
      observacaoCreItem: creItem.txDescricaoAnexo,
      quantidadePendencias: creItem.qtPendencias || 0,
      tipoDocumentoId: creItem.tipoPendenciaId,
      vlRisco: Number(creItem.vlCalcRisco),
    }))

    creAnaliseItens = [...creAnaliseItens, ...newCreItensList]


    const creAnaliseRequestDto = {
      crEitensADeletar: listPendenciaOnDelete,
      creItemAnalises: creAnaliseItens,
      creObservacoes: creObservacoes,
      das: das,
      gfip: gfip,
      gps: gps,
      idAnalista: user.IdUsuario,
      idContrato: cre.idContrato,
      idCre: cre.idCre,
      qtAnalises: numeroAnalises,
      qtTotalEfetivo: parseInt(qtTotalEfetivo)
    }
    //setListNewItensAnalise([])
    return creAnaliseRequestDto
  }

  const handleSalvarAnaliseCre = async () => {
    setLoading('loading')
    const creAnaliseRequestDto = getNewAnalises()

    AddAnalyzeCREServices()
      .updateCREAnalise(creAnaliseRequestDto)
      .then((response) => {
        if (response.status === 200) {
          saveCre.current = true
          showModal({
            handleConfirm() {
              handleGetCreInicial(false, false, true)
            },
            hideButtonCancel: true,
            message: 'Processo de análise do CRE, concluído com sucesso!',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
          setListNewItensAnalise([])
          setListPendenciaOnDelete([])
        }
        localStorage.removeItem('dados')
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.message ||
            error.mensagem ||
            'Não foi possivel salvar item de analise.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleLiberado = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const newValue = event.target.value as string; // Certifique-se de que o valor é uma string
    const analiseId = event.target.name; // O ID do item de análise que está sendo atualizado
    setListAnalises((prevState) =>
      prevState.map((analise) =>
        analise.id === analiseId // Verifica se o ID da análise corresponde ao ID do item alterado
          ? {
            ...analise,
            liberado: newValue // Atualiza o valor liberado com o novo valor selecionado
          }
          : analise
      )
    )
  }

  const handleQtdPendencias = (event: React.ChangeEvent<HTMLInputElement>) => {
    setListAnalises((prevState) =>
      prevState.map((analise) =>
        analise.id === event.target.name
          ? {
            ...analise,
            flQtdPendChange: true,
            qtPendencias: event.target.value.replace(/[^0-9]/g, '')
          }
          : analise
      )
    )
  }

  const handleDescricaoAnexo = (event: React.ChangeEvent<HTMLInputElement>) => {
    setListAnalises((prevState) =>
      prevState.map((analise: RequestCreateItemAnalise) =>
        analise.id === event.target.name
          ? {
            ...analise,
            flDescChange: true,
            txDescricaoAnexo: event.target.value
          }
          : analise
      )
    )
  }

  const getTableDataEffective = async (idMovimentacao: number) => {
    const requestQUERY = {
      IdMovimentacao: idMovimentacao,
      PageNumber: page,
      PageSize: rowsPerPage
    }

    setLoading('loading')

    await AddAnalyzeCREServices()
      .getEfetivoMovimentacao(requestQUERY)
      .then((response) => {
        if (response.status !== 200) throw new Error(response.statusText)
        setTotalItems(response.data.pageCount)
        const formattedTableData = response?.data?.items?.map((data) => {
          return {
            ...data,
            cdCategoria: optsCategoria[data?.cdCategoria?.trim()],
            cdGenero: optsGenero[data?.cdGenero?.trim()],
            cdNacionalidade: optsNacionalidade[data?.cdNacionalidade?.trim()]
          }
        })

        setEfetivoTableData(formattedTableData)
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        setMsgErro(
          error?.message || 'Não foi possível obter os Efetivos Cadastrados'
        )
        setLoading('error')
        setLoading('idle')
      })
  }

  useEffect(() => {
    getTableDataEffective(cre?.idMovimentacao)
  }, [page, rowsPerPage])

  const handleObservacaoMovDocItem = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setListAnalises((prevState) =>
      prevState.map((analise: RequestCreateItemAnalise) =>
        analise.historico
          ? analise.historico.map(
            (item) => String(item.idMovDocumentoItem) === event.target.name
          )
            ? {
              ...analise,
              historico: analise.historico.map((el) =>
                String(el.idMovDocumentoItem) === event.target.name
                  ? {
                    ...el,
                    txObservacaoMovDocItem: event.target.value
                  }
                  : el
              )
            }
            : analise
          : analise
      )
    )
  }

  const handleReset = () => {
    exitComponent()
    handleChangeName('Adicionar Novo')
    setBuscouCre(false)
    setPage(1)
    reset()
  }

  const handleRedirecionarBloqueio = () => {
    history.push({
      pathname: '/ngt/folha-registro',
      state: {
        cdContrato: cre.cdContrato,
        dtCompetencia: competencia,
        idCreExist: cre.idCre,
        idFornecedor: cre.idFornecedor,
        nmFornecedor: cre.nmFornecedor,
        pathBack: '/ngt/analise-cre',
        tabBack: 1
      }
    })
  }

  const voltarPagina = () => {
    exitComponent()
    if (location.hash.replace('#', '') === pathBack) {
      history.replace({
        pathname: pathBack,
        state: {
          tab: tabBack
        }
      })
      localStorage.removeItem('dados')
    } else {
      history.push({
        pathname: pathBack,
        state: {
          tab: tabBack
        }
      })
      localStorage.removeItem('dados')
    }
  }

  const ativarConsulta = () => {
    setIniciarPing(false)
    setNovaAnalise(false)
    handleGetCreInicial(true, true, true)
  }

  const showModalQuestions = (onSearchButton: boolean) => {
    if (onSearchButton) {
      setLoading('loading')
      AddAnalyzeCREServices()
        .verificarCreExistente({
          anoMes: FORMAT.formatYYYYMM(competencia),
          cdContrato: codigoContrato
        })
        .then((resp) => {
          if (!resp.data.sucesso) {
            setLoading('idle')
            showModal({
              hideButtonCancel: true,
              message: resp?.data?.mensagem || 'Cre já existente!',
              txtButtonConfirm: 'Fechar',
              type: 'alert'
            })
          } else {
            handleGetCreInicial(false)
          }
        })
        .catch(() => {
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Ocorreu um erro ao verificar se o Cre é existente.',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
      return
    }
    if (idCreAnalise && idCreAnalise !== 0) {
      if (isConsult) {
        ativarConsulta()
      } else {
        showModal({
          async handleCancel() {
            ativarConsulta()
          },
          async handleConfirm() {
            await handleGetCreInicial(false)
          },
          async handleThird() {
            voltarPagina()
          },
          hideButtonConfirm: creOcupado,
          hideThirdButton: false,
          message: creOcupado
            ? 'O cre atualmente está sendo analisado, gostaria de consultá-lo?'
            : 'Deseja "consultar" ou "analisar" o CRE?',
          titleModal: 'Atenção',
          txtButtonCancel: 'Consultar',
          txtButtonConfirm: 'Analisar',
          txtButtonThird: 'Voltar',
          type: 'alert'
        })
      }
    } else {
      handleGetCreInicial(false)
    }
  }

  ////// Atualização do estado de Análise Cre
  const handleAtualizacaoAnalise = async () => {
    let falhasNoPing = 0
    if (iniciarPing) {
      try {
        const obj: RequestSetDisponibilidade = {
          creId: idCre.current
        }

        const pingResponse = await AddAnalyzeCREServices().manterCreOcupado(obj)

        if (pingResponse.status !== 200) {
          throw new Error('A atualização no monitoramento deste CRE falhou.')
        }

        if (hasConnectionLostError()) {
          connectionLostError()
        }
      } catch (erros: any) {
        falhasNoPing += 1
        if (falhasNoPing === 3) {
          showModal({
            handleConfirm() {
              voltarPagina()
            },
            hideButtonCancel: true,
            message: 'A atualização no monitoramento deste CRE falhou.',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        } else {
          return
        }
      }
    }
  }

  const VerificarDisponibilidadeCRE = async () => {
    try {
      setLoading('loading')
      const disponivel =
        await AddAnalyzeCREServices().verificarDisponibilidadeCre([idCreExist])

      if (!disponivel?.data?.sucesso) {
        throw new Error(
          `${disponivel?.data?.mensagem ||
          'Ocorreu um erro ao verificar disponibilidade do CRE'
          }`
        )
      }

      setLoading('idle')
      return disponivel
    } catch (error: any) {
      setLoading('idle')
      throw showModal({
        handleConfirm() {
          voltarPagina()
        },
        hideButtonCancel: true,
        message:
          error.message ||
          error.messagem ||
          'Ocorreu um erro ao verificar disponibilidade do CRE',
        titleModal: 'Alerta',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const handleDeletePendency = (
    creItemId: number | String,
    isIdItemCre: Boolean
  ) => {
    if (typeof creItemId === 'string' || creItemId instanceof String) {
      setListAnalises((prevState: RequestCreateItemAnalise[]) => [
        ...prevState.filter((item) => item?.id !== creItemId)
      ])
      if (listNewItensAnalise.find((item) => item?.id === creItemId)) {
        setListNewItensAnalise((prevState) => [
          ...prevState.filter((item) => item?.id !== creItemId)
        ])
      }
      return
    }

    if (isIdItemCre) {
      const requestObj: RequestDeleteCodigoCRE = {
        competencia: competencia,
        creItemId,
        matriculaUsuarioLogado: usuarioCsn.NmMatricula.trim()
      }

      if (!listPendenciaOnDelete.includes(requestObj)) {
        setListPendenciaOnDelete((prevState) => [...prevState, requestObj])
        setListAnalises((prevState: RequestCreateItemAnalise[]) => [
          ...prevState.filter((item) => item?.idCreItem !== creItemId)
        ])
      }
    } else {
      const idMovDocumento = creItemId
      const requestObj: RequestDeleteCodigoCRE = {
        competencia: competencia,
        creItemId: idMovDocumento as number,
        matriculaUsuarioLogado: usuarioCsn.NmMatricula.trim()
      }

      if (!listPendenciaOnDelete.includes(requestObj)) {
        setListPendenciaOnDelete((prevState) => [...prevState, requestObj])
        setListAnalises((prevState: RequestCreateItemAnalise[]) => [
          ...prevState.filter(
            (item) => item?.idMovDocumento !== (idMovDocumento as number)
          )
        ])
      }
    }
  }

  useEffect(() => {
    if (idCreExist) {
      const creDisponivel = VerificarDisponibilidadeCRE()
      creDisponivel.then((resp) => {
        setCreOcupado(resp?.data?.entity[0]?.creOcupado)
      })
    }
  }, [idCreExist])

  useEffect(() => {
    const interval = setInterval(handleAtualizacaoAnalise, 5000)
    return () => clearInterval(interval)
  }, [iniciarPing])

  //////
  useEffect(() => {
    if (codigoContrato) {
      clearErrors('cdContrato')
    } else if (!primeiroAcesso) {
      setError('cdContrato', {
        message: 'Campo Obrigatório'
      })
    }
  }, [codigoContrato])

  // Exibição de modal para controle de usabilidade da tela (Consulta ou Análise)
  useEffect(() => {
    if (creOcupado !== null) {
      if (!hasQuestion) {
        showModalQuestions(false)
        setHasQuestion(true)
      }
    }
  }, [creOcupado])

  /*
    Limpeza com dos campos parametrizados pela chamada
    do componente anterior, caso de erro na requisição
  */
  useEffect(() => {
    if (
      !pesquisaComSucesso &&
      codigoContrato === cdContratoCre &&
      competencia === String(NuAnoMesCompetenciaCre)
    ) {
      setValue('cdContrato', '')
      setValue('nmFornecedor', '')
      setValue('dtEntradaCRE', null)
      setValue('dtRetornoCRE', null)
      setValue('dtLiberacaoCRE', null)
      setValue('NuAnoMesCompetencia', null)
    }
  }, [codigoContrato, competencia, pesquisaComSucesso])

  return (
    <Form
      onSubmit={handleSubmit(() => undefined)}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <HeaderNovoCRE
        checklist={isConsult || cre?.flChecklist}
        idCre={idCreExist}
        control={control}
        errors={errors}
        isAnaliseCre={!buscouCre}
        flBloqueado={flBloqueado}
        novaAnalise={novaAnalise}
        flLiberado={flLiberado}
        handleGetCreInicial={showModalQuestions}
        StartAnalyze={handleGetCreInicialConsulting}
        nmFornecedor={nomeFornecedor}
        cdContratoSelected={codigoContrato}
        setNmFornecedor={handleSetNmFornecedor}
        nmCentroPlanta={ContratoNmCentro}
      />
      {buscouCre && isChecklist !== null && (
        <>
          <DadosEfetivoCollapse
            control={control}
            errors={errors}
            disabledFunctions={isConsult}
            novaAnalise={novaAnalise}
            flStatusMoblizacao={statusMobilizacao}
          />
          {haveMobilizacao && (
            <TipoEfetivoCollapse control={control} errors={errors} />
          )}

          {haveMobilizacao && (
            <PagamentoCollpase control={control} errors={errors} />
          )}

          {haveMobilizacao && (
            <EfetivosCadastradosCollapse
              control={control}
              errors={errors}
              tableInfos={tableData}
              setRowsPerPage={setRowsPerPage}
              tableData={efetivoTableData}
            />
          )}

          {haveMobilizacao && (
            <EncargosCollapse
              control={control}
              errors={errors}
              disabledFunctions={isConsult}
              novaAnalise={novaAnalise}
            />
          )}

          {haveMobilizacao && (
            <DenunciaAlertaCollapse control={control} errors={errors} />
          )}

          {hasContratoPrincipal && (
            <ContratoPrincipalCollapse control={control} errors={errors} />
          )}

          {haveMobilizacao && (
            <DemaisInformacoesCollapse
              control={control}
              errors={errors}
              disabledFunctions={isConsult}
              novaAnalise={novaAnalise}
            />
          )}

          <AnaliseCollapse
            disabledFunctions={isConsult}
            listAnalises={listAnalises}
            handleLiberado={handleLiberado}
            handleQtdPendencias={handleQtdPendencias}
            novaAnalise={novaAnalise}
            resetPage={handleReset}
            handleAddAnalise={handleAddAnalise}
            handleSalvarAnaliseCre={handleSalvarAnaliseCre}
            handleObservacaoMovDocItem={handleObservacaoMovDocItem}
            handleDescricaoAnexo={handleDescricaoAnexo}
            fornecedorBloqueado={fornecedorBloqueado}
            handleRedirecionarBloqueio={handleRedirecionarBloqueio}
            handleDeletePendency={handleDeletePendency}
            isChecklist={isChecklist}
          />
        </>
      )}
      {NuAnoMesCompetenciaCre && cdContratoCre && pathBack && (
        <Row marginTop={SPACING.spacing10} justifyContent="flex-end">
          <Button
            onClick={() => voltarPagina()}
            variantButton="outlined"
            text="Voltar"
          />
        </Row>
      )}
    </Form>
  )
}
